.recentBox {
    border: 1px solid var(--exo-color-border-secondary);
    border-radius: 10px;
    padding: 16px 20px;
    background: var(--exo-color-background);
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.recentHeading {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: var(--exo-color-font);
}

.actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.viewAll {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 13px;
    color: var(--exo-color-brand);
}

.viewAll:hover {
    text-decoration: underline;
}

.emptyTitle {
    margin: 40px 0;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    color: var(--exo-color-font);
}

.cardRow {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.cardWrap {
    width: 180px;
    flex-shrink: 0;
}

.allConnectorsCardRow {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 12px;
}

.noResults {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.idpSetupAlert {
    display: flex;
    margin-bottom: var(--exo-spacing-medium);
}

.idpSetupBody {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-medium);
    height: 1.5rem;
}

.idpSetupText {
    font-size: var(--exo-font-size-x-small);
}
